module.exports = __webpack_public_path__ + "static/media/stefaanVanDenBogaert.da86d31a.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/stefaanVanDenBogaert.jpg
// module id = 1591
// module chunks = 1